import { BaseObject } from "./base-object.model";
import { VASRestService } from "../../services/api/vas-rest";
import { Observable } from "rxjs/Observable";
import { AppFacade } from "../../services/app-facade/app-facade.service";
import { ApiRequestOptions } from "../../services/api/request-options";
import { of } from "rxjs/observable/of";
import { _throw } from "rxjs/observable/throw";
import { RequestMethod, Response } from "@angular/http";

export abstract class BaseObjectApiFacade<T extends BaseObject> {

    constructor(protected appFacade: AppFacade, protected api: VASRestService, protected entityName: string) {

    }

    protected getEntityName(): string {
        return this.entityName;
    }

    abstract get(...args): Observable<T>;

    abstract getAll(...args): Observable<Array<T>>;

    protected GET(route, options?: ApiRequestOptions): Observable<T> {
        return this.api.simpleGet(route, options)
            .map(response => response.json());
    }

    protected CGET(route, options?: ApiRequestOptions): Observable<Array<T>> {
        return this.api.simpleGet(route, options)
            .map(response => {
                return response.json();
            })
            .map(objects => {
                return objects || [];
            })
            .catch(error => {
                switch (error.status) {
                    case 404: {
                        return of([]);
                    }
                    default:
                        return _throw(error);
                }
            });
    }

    protected PATCH(route, body, options?: ApiRequestOptions): Observable<Response> {
        const request = this.api.createRequestFromOptions(route, options, RequestMethod.Patch);
        request.setBody(body);
        return request.execute();
    }

    protected POST(route, body, options?: ApiRequestOptions): Observable<Response> {
        const request = this.api.createRequestFromOptions(route, options, RequestMethod.Post);
        request.setBody(body);
        return request.execute();
    }

    protected DELETE(
        route: string,
        options?: ApiRequestOptions
    ): Observable<Response> {
        const request = this.api.createRequestFromOptions(
            route,
            options,
            RequestMethod.Delete
        );
        return request.execute();
    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/base-object/base-object.api-facade.ts